import { useAuthStore } from '@/stores/auth';
import { isSupportedChainId, SupportedChainId } from '@packet/constants/AppSupportChains';
import { RolePermission } from '@packet/management/src/DTO/role';
import { useCallback, useMemo } from 'react';
import { Hash } from 'viem';

export interface UserPermissionItem {
  chainId: SupportedChainId;
  assetId: Hash;
  source: RolePermission;
}
export interface UserPermissions {
  asset: UserPermissionItem[];
  freeze: UserPermissionItem[];
}

export const usePermissions = (): UserPermissions => {
  const { user } = useAuthStore();

  const permissions = useMemo(() => {
    const permissionMap: UserPermissions = {
      asset: [],
      freeze: [],
    };
    if (!user || !user.roles) return permissionMap;
    user.roles.forEach((role) => {
      if (!role.permissions) return;
      role.permissions.map((permission) => {
        const [key, assetId, chain_id] = permission.flag.split(':');
        if (key in permissionMap) {
          const chainId = Number(chain_id);
          if (isSupportedChainId(chainId) === false) return;
          permissionMap[key as keyof UserPermissions].push({
            chainId,
            assetId: assetId as Hash,
            source: permission,
          });
        }
      });
    });
    return permissionMap;
  }, [user]);

  return permissions;
};

export const useHasPermission = (permissionKey: keyof UserPermissions, chainId?: SupportedChainId, assetId?: Hash) => {
  const permissions = usePermissions();
  return useMemo(() => {
    return permissions[permissionKey].some((p) => p.chainId === chainId && p.assetId === assetId);
  }, [permissions, chainId, assetId, permissionKey]);
};
